<template>
  <div>
    <section class="xs-banner service-banner contet-to-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-5 align-self-center">
            <div class="xs-banner-content">
              <h1 class="banner-sub-title wow fadeInLeft">Who we are</h1>
              <h2 class="banner-title wow fadeInLeft" data-wow-duration="1.5s">ABOUT EPIS Cloud</h2>
              <ul class="breadcrumbs list-inline wow fadeInLeft" data-wow-duration="2s">
                <li>
                  <router-link :to="{ path: '' }">
                    Home
                  </router-link>
                <li>About</li>
              </ul>
              <p class="wow fadeInUp" data-wow-duration="1.5s"></p>
            </div><!-- .xs-banner-content END -->
          </div>
          <div class="col-lg-6 col-md-7">
            <div class="inner-welcome-image-group">
              <img src="../assets/images/about-bg.png" alt="Welcome banner image">
              <img src="../assets/images/info-1.png" class="banner-ico banner-ico-1"
                   alt="banner icon"><img src="../assets/images/board.png"
                                          class="banner-ico banner-ico-2" alt="banner icon"></div>
          </div>
        </div><!-- .row END -->
      </div><!-- .container END -->
    </section>
    <div class="page" role="main">
      <div class="builder-content">
        <!-- full-width-content -->
        <div id="post-463" class="full-width-content post-463 page type-page status-publish hentry">
          <div data-elementor-type="wp-post" data-elementor-id="463" class="elementor elementor-463"
               data-elementor-settings="[]">
            <div class="elementor-inner">
              <div class="elementor-section-wrap">
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-c19e209 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="c19e209" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-5b747e9"
                        data-id="5b747e9" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-ba9fc51 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="ba9fc51" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ce2e02d"
                                    data-id="ce2e02d" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-385cf19"
                                    data-id="385cf19" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-f19df5f elementor-widget elementor-widget-xs-heading"
                                          data-id="f19df5f" data-element_type="widget"
                                          data-widget_type="xs-heading.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-heading">
                                              <h3 class="heading-sub-title">Who We Are</h3>
                                              <h2 class="heading-title">MEET <span>EPIS Cloud</span></h2>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b653a16"
                                    data-id="b653a16" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-fbfb936 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="fbfb936" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-df300c4"
                                    data-id="df300c4" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-1200a74"
                                    data-id="1200a74" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-660c6e5 elementor-aspect-ratio-169 elementor-widget elementor-widget-video"
                                          data-id="660c6e5" data-element_type="widget"
                                          data-settings="{&quot;youtube_url&quot;:&quot;https:\/\/www.youtube.com\/watch?v=9uOETcuFjbE&quot;,&quot;show_image_overlay&quot;:&quot;yes&quot;,&quot;image_overlay&quot;:{&quot;url&quot;:&quot;https:\/\/episcloud.com\/wp-content\/uploads\/2018\/07\/video-popup-bg.jpg&quot;,&quot;id&quot;:482},&quot;lightbox&quot;:&quot;yes&quot;,&quot;video_type&quot;:&quot;youtube&quot;,&quot;controls&quot;:&quot;yes&quot;,&quot;aspect_ratio&quot;:&quot;169&quot;}"
                                          data-widget_type="video.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-wrapper elementor-open-lightbox">
                                              <div class="elementor-custom-embed-image-overlay"
                                                   data-elementor-open-lightbox="yes"
                                                   data-elementor-lightbox="{&quot;type&quot;:&quot;video&quot;,&quot;videoType&quot;:&quot;youtube&quot;,&quot;url&quot;:&quot;https:\/\/www.youtube.com\/embed\/9uOETcuFjbE?feature=oembed&amp;start&amp;end&amp;wmode=opaque&amp;loop=0&amp;controls=1&amp;mute=0&amp;rel=0&amp;modestbranding=0&quot;,&quot;modalOptions&quot;:{&quot;id&quot;:&quot;elementor-lightbox-660c6e5&quot;,&quot;entranceAnimation&quot;:&quot;&quot;,&quot;entranceAnimation_tablet&quot;:&quot;&quot;,&quot;entranceAnimation_mobile&quot;:&quot;&quot;,&quot;videoAspectRatio&quot;:&quot;169&quot;}}">
                                                <img width="730" height="400"
                                                     src="../assets/images/video-popup-bg.jpg"
                                                     class="attachment-full size-full" alt="" loading="lazy"
                                                     srcset="../assets/images/video-popup-bg.jpg 730w, ../assets/images/video-popup-bg-300x164.jpg 300w"
                                                     sizes="(max-width: 730px) 100vw, 730px" draggable="false">
                                                <div class="elementor-custom-embed-play xs-video-popup gloosy-btn"
                                                     role="button">
                                                  <i class="icon icon-play2" aria-hidden="true"></i>
                                                  <span class="elementor-screen-only">Play Video</span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="xs-overlay xs-bg-black"></div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ce3484d"
                                    data-id="ce3484d" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-2690de2 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="2690de2" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-772b5ef"
                        data-id="772b5ef" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-60f310d"
                        data-id="60f310d" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-7d8b806 elementor-widget elementor-widget-xs-heading"
                              data-id="7d8b806" data-element_type="widget" data-widget_type="xs-heading.default">
                              <div class="elementor-widget-container">
                                <div class="xs-heading">
                                  <h3 class="heading-sub-title">Best Hosting</h3>
                                  <h2 class="heading-title">WHY <span>CHOOSE US</span></h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-585abc9"
                        data-id="585abc9" data-element_type="column">
                        <div class="elementor-column-wrap">
                          <div class="elementor-widget-wrap">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-d186241 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="d186241" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-af7e844 animated-slow animated fadeInUp"
                        data-id="af7e844" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:0.7}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-d8c0e9d elementor-widget elementor-widget-xs-image-box"
                              data-id="d8c0e9d" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-1.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">99.9% Uptime Guarantee</h4>
                                  <p>Share processes and data secure
                                    lona need to know basis</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-82eda63 animated-slow animated fadeInUp"
                        data-id="82eda63" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:1.5}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-6d96648 elementor-widget elementor-widget-xs-image-box"
                              data-id="6d96648" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-2.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Safe and Secured</h4>
                                  <p>Our team assured your web site is always safe and secure</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-923a80d animated-slow animated fadeInUp"
                        data-id="923a80d" data-element_type="column"
                        data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:2}">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-889caab elementor-widget elementor-widget-xs-image-box"
                              data-id="889caab" data-element_type="widget" data-widget_type="xs-image-box.default">
                              <div class="elementor-widget-container">
                                <div class="why-choose-us-block">
                                  <div class="choose-us-img">
                                    <img width="254" height="190"
                                         src="../assets/images/choose-us-3.png"
                                         class="attachment-full size-full" alt="" loading="lazy" draggable="false">
                                  </div>
                                  <h4 class="xs-title">Our Dedicated Support</h4>
                                  <p>We finally found a host that truly understood the unique</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-450dcaf elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="450dcaf" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e3bee51"
                        data-id="e3bee51" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-efbd8ed elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="efbd8ed" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-34e5f7a"
                                    data-id="34e5f7a" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-9c5dae0"
                                    data-id="9c5dae0" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-ff9e8e2 elementor-widget elementor-widget-xs-heading"
                                          data-id="ff9e8e2" data-element_type="widget"
                                          data-widget_type="xs-heading.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-heading">
                                              <h3 class="heading-sub-title">Our Office</h3>
                                              <h2 class="heading-title">LIFE AT <span>EPIS Cloud</span></h2>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-8d0f2da"
                                    data-id="8d0f2da" data-element_type="column">
                                    <div class="elementor-column-wrap">
                                      <div class="elementor-widget-wrap">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-17246cf elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="17246cf" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-8205c30"
                                    data-id="8205c30" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-a725e78 elementor-widget elementor-widget-image"
                                          data-id="a725e78" data-element_type="widget" data-widget_type="image.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img width="350" height="359"
                                                   src="../assets/images/office-img-1.jpg"
                                                   class="attachment-large size-large" alt="" loading="lazy"
                                                   srcset="../assets/images/office-img-1.jpg 350w, ../assets/images/office-img-1-292x300.jpg 292w"
                                                   sizes="(max-width: 350px) 100vw, 350px" draggable="false"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-e563171"
                                    data-id="e563171" data-element_type="column"
                                    data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-79d6e1b elementor-widget elementor-widget-heading"
                                          data-id="79d6e1b" data-element_type="widget"
                                          data-widget_type="heading.default">
                                          <div class="elementor-widget-container">
                                            <h2 class="elementor-heading-title elementor-size-default">Do you want to
                                              join our Team?
                                              <gwmw style="display:none;"></gwmw>
                                            </h2>
                                          </div>
                                        </div>
                                        <div
                                          class="elementor-element elementor-element-ef5870c elementor-align-center elementor-widget elementor-widget-xs-button"
                                          data-id="ef5870c" data-element_type="widget"
                                          data-widget_type="xs-button.default">
                                          <div class="elementor-widget-container">
                                            <a href="#" target="_self" class="xs-btn btn btn-primary">
                                              <span class="xs-button-icon xs-align-icon-left"><i class=""
                                                                                                 aria-hidden="true"></i></span>
                                              <span class="xs-button-text">Waiting For The Announcement</span>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-2bc58fd elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="2bc58fd" data-element_type="section">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-d989a7c"
                                    data-id="d989a7c" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-ace48df elementor-widget elementor-widget-image"
                                          data-id="ace48df" data-element_type="widget" data-widget_type="image.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img width="730" height="460"
                                                   src="../assets/images/office-img-2.jpg"
                                                   class="attachment-large size-large" alt="" loading="lazy"
                                                   srcset="../assets/images/office-img-2.jpg 730w, ../assets/images/office-img-2-300x189.jpg 300w"
                                                   sizes="(max-width: 730px) 100vw, 730px" draggable="false"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-3172797"
                                    data-id="3172797" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-9ad996c elementor-widget elementor-widget-image"
                                          data-id="9ad996c" data-element_type="widget" data-widget_type="image.default">
                                          <div class="elementor-widget-container">
                                            <div class="elementor-image">
                                              <img width="320" height="299"
                                                   src="../assets/images/office-img-3.jpg"
                                                   class="attachment-large size-large" alt="" loading="lazy"
                                                   srcset="../assets/images/office-img-3.jpg 320w, ../assets/images/office-img-3-300x280.jpg 300w"
                                                   sizes="(max-width: 320px) 100vw, 320px" draggable="false"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-4fbed78 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="4fbed78" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2cc001b"
                        data-id="2cc001b" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <section
                              class="elementor-section elementor-inner-section elementor-element elementor-element-65bbce6 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                              data-id="65bbce6" data-element_type="section"
                              data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                              <div class="elementor-container elementor-column-gap-default">
                                <div class="elementor-row">
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-b7a5ade"
                                    data-id="b7a5ade" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-282da42 elementor-widget elementor-widget-xs-call-to-action-box"
                                          data-id="282da42" data-element_type="widget"
                                          data-widget_type="xs-call-to-action-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-feature-group">
                                              <div class="media">
                                                <div class="feature-img d-flex">
                                                  <img width="122" height="138"
                                                       src="../assets/images/sheild-2.png"
                                                       class="attachment-full size-full" alt="" loading="lazy"
                                                       draggable="false"></div>
                                                <div class="media-body feature-content">
                                                  <h4 class="xs-title">Days money back guarantee</h4>
                                                  <p>Share processes an data secure lona need to know basis without the
                                                    need.</p>
                                                  <div class="xs-btn-wraper">
                                                    <a href="" class="btn btn-secondary"></a>
                                                  </div>
                                                </div>
                                              </div>
                                              <span class="icon icon-dollar watermark-icon"></span>
                                            </div><!-- .xs-feature-group END -->
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-96c7d24"
                                    data-id="96c7d24" data-element_type="column">
                                    <div class="elementor-column-wrap elementor-element-populated">
                                      <div class="elementor-widget-wrap">
                                        <div
                                          class="elementor-element elementor-element-c2ec37c elementor-widget elementor-widget-xs-call-to-action-box"
                                          data-id="c2ec37c" data-element_type="widget"
                                          data-widget_type="xs-call-to-action-box.default">
                                          <div class="elementor-widget-container">
                                            <div class="xs-feature-group">
                                              <div class="media">
                                                <div class="feature-img d-flex">
                                                  <img width="129" height="138"
                                                       src="../assets/images/cloud-lock-2.png"
                                                       class="attachment-full size-full" alt="" loading="lazy"
                                                       draggable="false"></div>
                                                <div class="media-body feature-content">
                                                  <h4 class="xs-title">Build and protect your brand</h4>
                                                  <p>Share processes an data secure lona need to know basis without the
                                                    need.</p>
                                                  <div class="xs-btn-wraper">
                                                    <a href="" class="btn btn-secondary"></a>
                                                  </div>
                                                </div>
                                              </div>
                                              <span class="icon icon-dollar watermark-icon"></span>
                                            </div><!-- .xs-feature-group END -->
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-top-section elementor-element elementor-element-a56d644 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="a56d644" data-element_type="section"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div class="elementor-row">
                      <div
                        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f9c3303"
                        data-id="f9c3303" data-element_type="column">
                        <div class="elementor-column-wrap elementor-element-populated">
                          <div class="elementor-widget-wrap">
                            <div
                              class="elementor-element elementor-element-27cd88b elementor-widget elementor-widget-spacer"
                              data-id="27cd88b" data-element_type="widget" data-widget_type="spacer.default">
                              <div class="elementor-widget-container">
                                <div class="elementor-spacer">
                                  <div class="elementor-spacer-inner"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div> <!-- end full-width-content -->
      </div> <!-- end main-content -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/About.vue